export function LinkedFolderIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 2C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H4.13802C4.04811 13.6821 4 13.3467 4 13C4 12.8876 4.00505 12.7765 4.01495 12.6667H4C3.63181 12.6667 3.33333 12.3682 3.33333 12V6H12C12.3682 6 12.6667 6.29848 12.6667 6.66667V9.47135C13.1616 9.61134 13.614 9.85264 14 10.1714V6.66667C14 5.5621 13.1046 4.66667 12 4.66667H9L7.6 2.8C7.22229 2.29639 6.62951 2 6 2H4ZM7.33333 4.66667H3.33333V4C3.33333 3.63181 3.63181 3.33333 4 3.33333H6C6.20984 3.33333 6.40743 3.43213 6.53333 3.6L7.33333 4.66667Z"
        fill="currentColor"
      />
      <path
        d="M7.33333 10C5.86057 10 4.66667 11.1939 4.66667 12.6667C4.66667 14.1394 5.86057 15.3333 7.33333 15.3333H8C8.36819 15.3333 8.66667 15.0349 8.66667 14.6667C8.66667 14.2985 8.36819 14 8 14H7.33333C6.59695 14 6 13.403 6 12.6667C6 11.9303 6.59695 11.3333 7.33333 11.3333H8C8.36819 11.3333 8.66667 11.0349 8.66667 10.6667C8.66667 10.2985 8.36819 10 8 10H7.33333Z"
        fill="currentColor"
      />
      <path
        d="M10.6667 10C10.2985 10 10 10.2985 10 10.6667C10 11.0349 10.2985 11.3333 10.6667 11.3333H11.3333C12.0697 11.3333 12.6667 11.9303 12.6667 12.6667C12.6667 13.403 12.0697 14 11.3333 14H10.6667C10.2985 14 10 14.2985 10 14.6667C10 15.0349 10.2985 15.3333 10.6667 15.3333H11.3333C12.8061 15.3333 14 14.1394 14 12.6667C14 11.1939 12.8061 10 11.3333 10H10.6667Z"
        fill="currentColor"
      />
      <path
        d="M8 12C7.63181 12 7.33333 12.2985 7.33333 12.6667C7.33333 13.0349 7.63181 13.3333 8 13.3333H10.6667C11.0349 13.3333 11.3333 13.0349 11.3333 12.6667C11.3333 12.2985 11.0349 12 10.6667 12H8Z"
        fill="currentColor"
      />
    </svg>
  );
}
